<template>
  <div class="content-area">
    <div class="error-panel content-area">
      <infopanel v-once>
        <template slot="title"></template>
        <template slot="body">
          <div class="row">
            <div class="col-sm-12 col-xs-12 warning-text text-center">
              <h1>403 - Forbidden</h1>
              <p>
                You do not have permission to view this page, if you feel you should be able to
                please contact support.
              </p>
            </div>
          </div>
        </template>
      </infopanel>
    </div>
  </div>
</template>

<script>
import InfoPanel from '@/components/InfoPanel';

export default {
  components: {
    infopanel: InfoPanel,
  },
};
</script>

<style scoped>
.error-panel {
  margin-top: 140px;
}
</style>
